import React from 'react';
import NumberFormat from 'react-number-format';

type NumberFormatCustomProps = {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
};

const NumberFormatCustom = ({
  inputRef,
  onChange,
  name,
  ...others
}: NumberFormatCustomProps): JSX.Element => (
  <NumberFormat
    {...others}
    getInputRef={inputRef}
    thousandSeparator
    isNumericString
    prefix="$"
    allowNegative={false}
    decimalScale={2}
    onValueChange={(values): void => {
      onChange({
        target: {
          name,
          value: values.value,
        },
      });
    }}
  />
);

export default NumberFormatCustom;
